var _defs, _ellipse, _ellipse2, _path, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _path2, _line12, _line13, _line14, _line15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconMeasuringTape(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-tailored",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .icon-line--style {\n        fill: none;\n        stroke: #000;\n        stroke-width: 4px;\n        stroke-linejoin: round;\n      }\n\n      .icon-line--miter-limit {\n        stroke-miterlimit: 10;\n      }\n\n      .icon-line--linecap {\n        stroke-linecap: round;\n      }\n    "))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "icon-line--style icon-line--linecap icon-line--miter-limit",
    cx: 46.7,
    cy: 50.37,
    rx: 13.27,
    ry: 5.91
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "icon-line--style icon-line--linecap icon-line--miter-limit",
    cx: 47.1,
    cy: 50.41,
    rx: 39.53,
    ry: 15.04
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "icon-line--style icon-line--linecap icon-line--miter-limit",
    d: "M7.57,53.13V79c0,8.31,17.7,15,39.53,15s39.53-6.73,39.53-15v-27"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "icon-line--style icon-line--linecap icon-line--miter-limit",
    x1: 47.16,
    y1: 66.02,
    x2: 47.16,
    y2: 74.36
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "icon-line--style icon-line--linecap icon-line--miter-limit",
    x1: 66.58,
    y1: 63.59,
    x2: 66.58,
    y2: 72.25
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "icon-line--style icon-line--linecap icon-line--miter-limit",
    x1: 76.89,
    y1: 60.67,
    x2: 76.89,
    y2: 68.82
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "icon-line--style icon-line--linecap icon-line--miter-limit",
    x1: 57.01,
    y1: 65.09,
    x2: 57.01,
    y2: 73.75
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "icon-line--style icon-line--linecap icon-line--miter-limit",
    x1: 37.23,
    y1: 65.79,
    x2: 37.23,
    y2: 73.9
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "icon-line--style icon-line--linecap icon-line--miter-limit",
    x1: 27.37,
    y1: 64.05,
    x2: 27.37,
    y2: 72.4
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "icon-line--style icon-line--linecap icon-line--miter-limit",
    x1: 17.45,
    y1: 60.65,
    x2: 17.45,
    y2: 69
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "icon-line--style icon-line--linecap icon-line--miter-limit",
    x1: 17.68,
    y1: 80.49,
    x2: 17.68,
    y2: 88.84
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "icon-line--style icon-line--linecap icon-line--miter-limit",
    x1: 37.18,
    y1: 84.82,
    x2: 37.18,
    y2: 92.7
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "icon-line--style icon-line--linecap icon-line--miter-limit",
    x1: 56.79,
    y1: 84.65,
    x2: 56.79,
    y2: 92.07
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "icon-line--style icon-line--linecap icon-line--miter-limit",
    x1: 76.57,
    y1: 80.61,
    x2: 76.57,
    y2: 87.68
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "icon-line--style",
    d: "M86.69,57.13s8.08,8.08,17.42,8h15.46v25.5H103.3a22,22,0,0,1-16.61-8.65"
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "icon-line--style",
    x1: 112.07,
    y1: 65.55,
    x2: 112.07,
    y2: 90.01
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    className: "icon-line--style icon-line--linecap",
    x1: 94.42,
    y1: 63.02,
    x2: 94.42,
    y2: 70.86
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    className: "icon-line--style icon-line--linecap",
    x1: 101.8,
    y1: 65.09,
    x2: 101.8,
    y2: 72.94
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    className: "icon-line--style icon-line--linecap",
    x1: 98.23,
    y1: 81.01,
    x2: 98.23,
    y2: 88.86
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMeasuringTape);
export default __webpack_public_path__ + "static/media/icon-measuring-tape.431b2306.svg";
export { ForwardRef as ReactComponent };